import { Avatar } from 'antd';
import React from 'react';

import BooleanPreview from '@/components/BooleanPreview';
import ViewEditor from '@/components/Editor/ViewEditor';
import Email from '@/components/Email/index';

/**
 * This is not a component,
 * it is a function to render the Email component in a table cell
 * */
export const renderEmail = (email, item) => <Email item={item}>{email}</Email>;

/**
 * This is not a component,
 * it is a function to render the Url component in a table cell
 * */
export const renderUrl = (url = '', item, index, label) => {
  const href = url && (!url.startsWith('https://') && !url.startsWith('http://')) ? `https://${url}` : url;
  return <a href={href} target="_blank" rel="noreferrer">{label || url}</a>;
};

/**
 * This is not a component,
 * it is a function to render the Avatar component in a table cell
 * */
export const renderAvatar = (avatar) => <Avatar src={avatar}/>;

/**
 * This is not a component,
 * it is a function to render the Squared Avatar component in a table cell
 * */
export const renderSquareAvatar = (avatar) => <Avatar shape="square" src={avatar}/>;

/**
 * This is not a component,
 * it is a function to render the Html View component in a table cell
 * */
export const renderHTML = (value, record) => <ViewEditor value={value} record={record}/>;

/**
 * This is not a component,
 * it is a function to render the Avatar component in a table cell
 * */
export const renderBoolean = (value) => <BooleanPreview value={value}/>;
